import { render, staticRenderFns } from "./authorChange.vue?vue&type=template&id=4f450a4c&scoped=true"
import script from "./authorChange.vue?vue&type=script&lang=js"
export * from "./authorChange.vue?vue&type=script&lang=js"
import style0 from "./authorChange.vue?vue&type=style&index=0&id=4f450a4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f450a4c",
  null
  
)

export default component.exports